import axios from 'axios';
import { getApiBaseUrl } from '../config/api-base.js';

(function() {

    const ax = axios.create({
        baseURL: getApiBaseUrl(),
    });
    
    window.services = {
        validateSession() {
            return ax.get('/api/user/get');
        },
        google(data) {
            return ax.post('/api/user/google', data);
        },
        signup(data) {
            return ax.post('/api/user/create', data);
        },
        login(data) {
            return ax.post('/api/user/authenticate', data);
        },
        delete(data) {
            return ax.post('/api/user/delete', data);
        },
        resetPassword(data) {
            return ax.post('/api/user/reset-password', data);
        },
        getImages() {
            return ax.get('/api/image/get');
        },
        deleteImage(data) {
            return ax.post('/api/image/delete', data);
        },
        getPayments() {
            return ax.get('/api/payment/get');
        },
        getPurchase(data) {
            return ax.post('/api/payment/get', data);
        },
        recoverPurchase(data) {
            return ax.post('/api/payment/recover', data);
        },
        savePurchase(data) {
            return ax.post('/api/payment/purchase', data);
        },
        submitPayment(data) {
            return ax.post('/api/payment/save', data);
        },
        cancelSubscription() {
            return ax.post('/api/payment/cancel');
        },
        analyzeImage(file, restore) {
            let formData = new FormData();
            formData.append('image', file);
            formData.append('restore', restore ? 'true' : 'false');

            return ax.post('/api/image/analyze.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }
})();